module.exports = {
  INSURANCE: 'insurance',
  FEE: 'fee',
};
